import * as React from 'react';
import { useAppSetting } from '@contexts/appSetting/hooks/useAppSetting';
import { Header, HeaderProps } from './Header';

export type PageHeaderProps = Omit<HeaderProps, 'fontColor'>;

export const PageHeader: React.FC<PageHeaderProps> = props => {
    const { customUI } = useAppSetting();
    const showLogo = !!customUI?.header?.showLogo;
    const isTransparent = !!customUI?.header?.transparent;
    const hasBackgroundImage = customUI?.background?.showBackground && customUI?.background?.useBackgroundImage;
    const fontColor = isTransparent && hasBackgroundImage ? 0 : 800;

    return (
        <Header
            header={props.header}
            buttonIcon={props.buttonIcon}
            onButtonClick={props.onButtonClick}
            fontColor={fontColor}
            isTransparent={isTransparent}
            showLogo={showLogo}
            customLogo={props.customLogo}
        />
    );
};
